/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  generateGenericDocs,
  GenericMachine,
} from '_core/domain/Utils/Generic/Machines/GenericMachine';
import { IDocs } from '_core/types';
import { geoLocationApi as API } from '../Apis';

export const GetGeoLocationDocs: IDocs = generateGenericDocs(
  {
    title: 'GetGeoLocation',
    description: '',
    version: '0.0.1',
    codeToExecute: 'Services.AccountServices.getGeoLocation',
  },
  API.definitions,
);

const prepareCall = async (stateRequestParameters: any) => {
  const response = await API.call.get({
    locationType: stateRequestParameters.locationType,
    input: stateRequestParameters.input,
    language: stateRequestParameters?.language,
  });
  return response;
};

export const GetGeoLocationMachine = GenericMachine(prepareCall, {
  docs: GetGeoLocationDocs,
  definitions: API.definitions,
});
